export default __webpack_public_path__ + "static/media/trash-stand.ca65fd4f.svg";